import { render, staticRenderFns } from "./DuplicateLogin.vue?vue&type=template&id=3411320a&scoped=true"
import script from "./DuplicateLogin.vue?vue&type=script&lang=ts"
export * from "./DuplicateLogin.vue?vue&type=script&lang=ts"
import style0 from "./DuplicateLogin.vue?vue&type=style&index=0&id=3411320a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3411320a",
  null
  
)

export default component.exports